import React, { useEffect, useState } from "react";
import Dropdown from "./DropDown";
import FadeInComponent from "./FadeIn";
import { useController } from "react-hook-form";
import useWindowSize from "../../utils/hooks/useWindowSize";
import { Get } from "../network/httpClient";

const artistOptions = [
  {
    id: "PC1698918538166",
    name: "actor",
    type: "Artist"
  },
  {
    id: "PC1698754609475",
    name: "background dancer",
    type: "Artist"
  },
  {
    id: "PC1698813749364",
    name: "background dancer",
    type: "Artist"
  },
  {
    id: "PC1695463990515",
    name: "singer",
    type: "Artist"
  },
  {
    id: "PC1695463990512",
    name: "writer",
    type: "Artist"
  }
];

const recruiterOptions = [
  {
    id: "PC1697112621423",
    name: " Director",
    type: "Recruiter"
  },
  {
    id: "PC1696485776036",
    name: "assistant Director",
    type: "Recruiter"
  },
  {
    id: "PC1695886719257",
    name: "Film Producer",
    type: "Recruiter"
  },
  {
    id: "PC1696826478459",
    name: "Supporting Director",
    type: "Recruiter"
  }
];

const CategorySelect = ({ name, control, error }) => {
  const windowSize = useWindowSize();
  const [artistList, setArtistList] = useState([]);
  const [recruiterList, setRecruiterList] = useState([]);
  const [resetArtist, setResetArtist] = useState(false);
  const [resetRecruiter, setResetRecruiter] = useState(false);
  const { field } = useController({
    name,
    control,
    defaultValue: ""
  });

  const isMobileLandscape = windowSize.x > windowSize.y && windowSize.x <= 915;

  useEffect(() => {
    fetchArtistList();
    fetchRecruiterList();
  }, []);

  const fetchArtistList = async () => {
    try {
      const artistResponse = await Get("profileCategory/getList?categoryType=Artist");
      setArtistList(artistResponse.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRecruiterList = async () => {
    try {
      const recruiterResponse = await Get("profileCategory/getList?categoryType=Recruiter");
      setRecruiterList(recruiterResponse.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (name, option) => {
    console.log(name, option);
    if (name === "artist") {
      setResetRecruiter(!resetRecruiter);
    } else {
      setResetArtist(!resetArtist);
    }
    field.onChange(option.id);
  };

  return (
    <FadeInComponent>
      <div className="category-container">
        <label style={{ fontSize: 12, alignSelf: "flex-start", marginTop: 4 }}>Category</label>
        <div
          className="category-select-container"
          style={isMobileLandscape ? { flexDirection: "row" } : {}}>
          <Dropdown
            key={`artist-${resetArtist}`}
            name="artist"
            options={artistList}
            placeholder="Artist"
            onChange={handleChange}
          />
          <Dropdown
            key={`recruiter-${resetRecruiter}`}
            name="recruiter"
            options={recruiterList}
            placeholder="Recruiter"
            onChange={handleChange}
          />
        </div>
        {error && <div className="error">{error}</div>}
      </div>
    </FadeInComponent>
  );
};

export default CategorySelect;
